module.exports = __webpack_public_path__ + "img/CM-SS-25-Ford-Playful.e5019950.jpg";